import { createSlice } from "@reduxjs/toolkit";
import { RequestResults } from "../../common/RequestStatus";
import { getConversionTracking, getConversionTrackingStats, ConversionStats } from "./conversionTrackingAsyncThunk";
import { ConversionTrackingItem } from "../../../types/ConversionTracking";
import { RootState } from "../../store";

interface ConversionTrackingState {
    data: ConversionTrackingItem[];
    counts: number;
    limit: number;
    status: RequestResults;
    error: string | null;
    totalCount: number;
    draftIncompleteCount: number;
    draftCompletedCount: number;
    notPaidCount: number;
    paidCount: number;
    overdueCount: number;
    deletedCount: number;
    stats: ConversionStats | null;
    statsStatus: RequestResults;
}

const initialState: ConversionTrackingState = {
    data: [],
    counts: 0,
    limit: 10,
    status: RequestResults.idle,
    error: null,
    totalCount: 0,
    draftIncompleteCount: 0,
    draftCompletedCount: 0,
    notPaidCount: 0,
    paidCount: 0,
    overdueCount: 0,
    deletedCount: 0,
    stats: null,
    statsStatus: RequestResults.idle,
};

const conversionTrackingSlice = createSlice({
    name: "conversionTracking",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getConversionTracking.pending, (state) => {
                state.status = RequestResults.pending;
            })
            .addCase(getConversionTracking.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.counts = action.payload.counts;
                state.limit = action.payload.limit;
                state.totalCount = action.payload.totalCount;
                state.draftIncompleteCount = action.payload.draftIncompleteCount;
                state.draftCompletedCount = action.payload.draftCompletedCount;
                state.notPaidCount = action.payload.notPaidCount;
                state.paidCount = action.payload.paidCount;
                state.overdueCount = action.payload.overdueCount;
                state.deletedCount = action.payload.deletedCount;
                state.status = RequestResults.success;
            })
            .addCase(getConversionTracking.rejected, (state, action) => {
                state.status = RequestResults.failed;
                state.error = action.payload || "Failed to fetch conversion tracking data";
            })
            .addCase(getConversionTrackingStats.pending, (state) => {
                state.statsStatus = RequestResults.pending;
            })
            .addCase(getConversionTrackingStats.fulfilled, (state, action) => {
                state.stats = action.payload;
                state.statsStatus = RequestResults.success;
            })
            .addCase(getConversionTrackingStats.rejected, (state) => {
                state.statsStatus = RequestResults.failed;
            });
    },
});

export const selectConversionTracking = (state: RootState) => state.conversionTracking;

export default conversionTrackingSlice.reducer;
